import { Box } from "@mui/material";
import { useState } from "react";

import { useAppForm } from "components/Forms/AppForm";
import Subheader from "components/Subheader";
import { usePageTitle } from "hooks/usePageTitle";

import PpControls, { PpDisplayType } from "./components/Controls/PpControls";
import PpFilter from "./components/Filter/PpFilter";
import PpGridView from "./components/GridView/PpGridView";
import HeaderInfo from "./components/Header/HeaderInfo";
import PpHeader from "./components/Header/PpHeader";
import PpListView from "./components/ListView/PpListView";
import PpModals from "./components/PPModals/PpModals";
import PPTableView from "./components/UI/TableView/PPTableView";
import { ppFilterDefaultValues } from "./context/ppFilterDefaultValues";

import "components/Products/Products.css";

export default function ProtectionProfiles() {
  usePageTitle("NIAP - Protection Profiles");
  const [showFilters, setShowFilters] = useState(true);
  const [ppView, setPPView] = useState<PpDisplayType>("Table");

  const form = useAppForm({
    defaultValues: ppFilterDefaultValues,
  });

  const handleProductDisplay = (view: PpDisplayType) => {
    setPPView(view);
    setShowFilters(false);
  };
  const handleShowFilter = () => setShowFilters(!showFilters);

  return (
    <>
      <Subheader pageName={"Protection Profiles"} />

      <Box padding={1}>
        <PpHeader form={form} />

        <PpModals />

        <HeaderInfo form={form} />

        <PpControls
          showFilters={showFilters}
          onShowFilter={handleShowFilter}
          onDisplayChange={handleProductDisplay}
        />

        <Box display="flex" padding={1} height={"100%"}>
          <PpFilter show={showFilters} form={form} />

          {ppView === "Grid" && <PpGridView form={form} />}
          {ppView === "List" && <PpListView form={form} />}
          {ppView === "Table" && <PPTableView form={form} />}
        </Box>
      </Box>
    </>
  );
}
